import { useTranslation } from 'react-i18next';
import { KioskSectionTitle } from '../styles';

interface KioskSectionHeaderProps {
  titleKey: string;
}

const KioskSectionHeader = ({ titleKey }: KioskSectionHeaderProps) => {
  const [t] = useTranslation();
  return <KioskSectionTitle>{t(titleKey)}</KioskSectionTitle>;
};

export default KioskSectionHeader;
